export default "__VITE_ASSET__D5DcBmqP__"